import React from "react";
import NavigationDrawer from "../../components/navigationDrawer";
import { Typography, Container } from "@mui/material";
import { allColors } from "../../constants";
import "../tableStyle.css";

const callChargesData = [
  { id: 1, name: "Calls to landline (01,02 & 03)", value: "4p" },
  { id: 2, name: "Calls to major mobile networks", value: "16p" },
  { id: 3, name: "Connection charge – Landline", value: "18p" },
  { id: 3, name: "Connection charge – Mobile", value: "20p" },
];

const internationalCallChargesData = [
  { id: 1, name: "UK Local", value: "4p", value2: "18p" },
  { id: 2, name: "Antigua & Barbuda", value: "34.5p", value2: "16p" },
  { id: 3, name: "Antigua & Barbuda Mobile", value: "44.5p", value2: "16p" },
  { id: 4, name: "Ghana Mobile", value: "45.5p", value2: "16p" },
  { id: 5, name: "Hong Kong", value: "9p", value2: "12p" },
  { id: 6, name: "Hungary Mobile", value: "20p", value2: "16p" },
  { id: 7, name: "Ireland", value: "9p", value2: "16p" },
  { id: 8, name: "Ireland Dublin", value: "9p", value2: "16p" },
  { id: 9, name: "Ireland Mobile", value: "29p", value2: "14p" },
  { id: 10, name: "Iceland", value: "8p", value2: "14p" },
  { id: 11, name: "Korea South", value: "12p", value2: "16p" },
  { id: 12, name: "GUERNSEY", value: "2p", value2: "20p" },
  { id: 13, name: "Australia", value: "9p", value2: "16p" },
  { id: 14, name: "Australia Mobile", value: "22.5p", value2: "16p" },
  { id: 15, name: "Austria", value: "12p", value2: "16p" },
  { id: 16, name: "Belgium", value: "9p", value2: "16p" },
  { id: 17, name: "Belgium Mobile", value: "31p", value2: "16p" },
  { id: 18, name: "Bulgaria", value: "13.5p", value2: "16p" },
  { id: 19, name: "Bermuda", value: "13p", value2: "16p" },
  { id: 20, name: "Canada", value: "9p", value2: "16p" },
  { id: 21, name: "Switzerland", value: "37p", value2: "16p" },
  { id: 22, name: "Switzerland Mobile", value: "37p", value2: "16p" },
  { id: 23, name: "Cyprus Mobile", value: "13p", value2: "16p" },
  { id: 24, name: "Germany", value: "9p", value2: "14p" },
  { id: 25, name: "Germany Mobile", value: "33.5p", value2: "16p" },
  { id: 26, name: "Denmark Mobile", value: "28p", value2: "16p" },
  { id: 27, name: "Spain", value: "9p", value2: "16p" },
  { id: 28, name: "Spain Mobile", value: "21p", value2: "16p" },
  { id: 29, name: "Fiji Mobile", value: "50p", value2: "16p" },
  { id: 30, name: "France", value: "9p", value2: "16p" },
  { id: 31, name: "France Mobile", value: "13.5p", value2: "16p" },
  { id: 32, name: "Israel Mobile", value: "6.5p", value2: "16p" },
  { id: 33, name: "Italy", value: "9p", value2: "16p" },
  { id: 34, name: "Italy Mobile", value: "36p", value2: "16p" },
  { id: 35, name: "Netherlands", value: "9p", value2: "14p" },
  { id: 36, name: "Netherlands Mobile", value: "35.5p", value2: "16p" },
  { id: 37, name: "Norway", value: "9p", value2: "16p" },
  { id: 38, name: "Norway Mobile", value: "14p", value2: "16p" },
  { id: 39, name: "New Zealand", value: "9p", value2: "32p" },
  { id: 40, name: "New Zealand Mobile", value: "32p", value2: "16p" },
  { id: 41, name: "Pakistan", value: "23.5p", value2: "14p" },
  { id: 42, name: "Pakistan Mobile", value: "26.5p", value2: "16p" },
  { id: 43, name: "Papua New Guinea Mobile", value: "£1.46", value2: "16p" },
  { id: 44, name: "Poland Mobile", value: "18p", value2: "16p" },
  { id: 45, name: "Portugal", value: "9p", value2: "16p" },
  { id: 46, name: "Portugal Mobile", value: "22p", value2: "16p" },
  { id: 47, name: "Sweden", value: "9p", value2: "11p" },
  { id: 48, name: "Sweden Mobile", value: "13p", value2: "16p" },
  {
    id: 49,
    name: "Turkish Republic of Northern Cyprus",
    value: "23p",
    value2: "16p",
  },
  { id: 50, name: "USA", value: "9p", value2: "14p" },
  { id: 51, name: "USA Premium", value: "25p", value2: "16p" },
  { id: 52, name: "South Africa", value: "10p", value2: "16p" },
  { id: 53, name: "South Africa Mobile", value: "36.5p", value2: "16p" },
];

const tariffs = [
  {
    name: "VOIP Foundation NTS",
    description: "VOIP Foundation NTS (Included = Line Rental)",
    rrp: "£16.99",
  },
  {
    name: "VOIP Foundation Non-NTS",
    description: "VOIP Foundation Non-NTS (Included = Line Rental)",
    rrp: "£28.99",
  },
  {
    name: "VOIP Inclusive NTS",
    description: "VOIP Inclusive NTS (Included = Line Rental, Inclusive Calls)",
    rrp: "£22.99",
  },
  {
    name: "VOIP Inclusive",
    description: "VOIP Inclusive (Included = Line Rental, Inclusive Calls)",
    rrp: "£32.99",
  },
  {
    name: "SOGEA Business (0.5/0.5)",
    description:
      "SOGEA Business (0.5/0.5) (Included = Unlimited High Speed Fibre Broadband)",
    rrp: "£25.99",
  },
  {
    name: "SOGEA Premium (40/10)",
    description:
      "SOGEA Premium (40/10) (Included = Unlimited High Speed Fibre Broadband)",
    rrp: "£34.99",
  },
  {
    name: "SOGEA Ultra (80/20)",
    description:
      "SOGEA Ultra (80/20) (Included = Unlimited High Speed Fibre Broadband)",
    rrp: "£36.99",
  },
  {
    name: "SOGEA Business Foundation",
    description:
      "SOGEA Business Foundation (Included = Line Rental, Unlimited High Speed Fibre Broadband)",
    rrp: "£30.99",
  },
  {
    name: "SOGEA Business Inclusive",
    description:
      "SOGEA Business Inclusive (Included = Line Rental, Inclusive Calls, Unlimited High Speed Fibre Broadband)",
    rrp: "£35.99",
  },
  {
    name: "SOGEA Premium Foundation",
    description:
      "SOGEA Premium Foundation (Included = Line Rental, Unlimited High Speed Fibre Broadband)",
    rrp: "£39.99",
  },
  {
    name: "SOGEA Premium Inclusive",
    description:
      "SOGEA Premium Inclusive (Included = Line Rental, Inclusive Calls, Unlimited High Speed Fibre Broadband)",
    rrp: "£41.99",
  },
  {
    name: "SOGEA Ultra Foundation",
    description:
      "SOGEA Ultra Foundation (Included = Line Rental, Unlimited High Speed Fibre Broadband)",
    rrp: "£43.99",
  },
  {
    name: "SOGEA Ultra Inclusive",
    description:
      "SOGEA Ultra Inclusive (Included = Line Rental, Inclusive Calls, Unlimited High Speed Fibre Broadband)",
    rrp: "£45.99",
  },
  {
    name: "FTTP Basic (0.5/0.5)",
    description: "FTTP Basic (0.5/0.5) (Included = Unlimited FTTP Broadband)",
    rrp: "£31.99",
  },
  {
    name: "FTTP Standard (40/10)",
    description:
      "FTTP Standard (40/10) (Included = Unlimited Ultrafast FTTP Broadband)",
    rrp: "£38.99",
  },
  {
    name: "FTTP Premium (80/20)",
    description:
      "FTTP Premium (80/20) (Included = Unlimited Ultrafast FTTP Broadband)",
    rrp: "£40.99",
  },
  {
    name: "FTTP Express (115/20)",
    description:
      "FTTP Express (115/20) (Included = Unlimited Ultrafast FTTP Broadband)",
    rrp: "£42.99",
  },
  {
    name: "FTTP Ultra (160/30)",
    description:
      "FTTP Ultra (160/30) (Included = Unlimited Ultrafast FTTP Broadband)",
    rrp: "£44.99",
  },
  {
    name: "FTTP Basic Foundation (0.5/0.5)",
    description:
      "FTTP Business Foundation (Included = Line Rental, Unlimited FTTP Broadband)",
    rrp: "£34.99",
  },
  {
    name: "FTTP Basic Inclusive (0.5/0.5)",
    description:
      "FTTP Basic Inclusive (0.5/0.5) (Included = Line Rental, Inclusive Calls, Unlimited FTTP Broadband)",
    rrp: "£38.99",
  },
  {
    name: "FTTP Standard Foundation (40/10)",
    description:
      "FTTP Standard Foundation (40/10) (Included = Line Rental, Inclusive Calls, Unlimited Ultrafast FTTP Broadband)",
    rrp: "£43.99",
  },
  {
    name: "FTTP Standard Inclusive (40/10)",
    description:
      "FTTP Standard Inclusive (40/10) (Included = Line Rental, Inclusive Calls, Unlimited Ultrafast FTTP Broadband)",
    rrp: "£47.99",
  },
  {
    name: "FTTP Premium Foundation (80/20)",
    description:
      "FTTP Premium Foundation (80/20) (Included = Line Rental, Unlimited Ultrafast FTTP Broadband)",
    rrp: "£46.99",
  },
  {
    name: "FTTP Premium Inclusive (80/20)",
    description:
      "FTTP Premium Inclusive (80/20) (Included = Line Rental, Inclusive Calls, Unlimited Ultrafast Ultra FTTP Broadband)",
    rrp: "£51.99",
  },
  {
    name: "FTTP Express Foundation (115/20)",
    description:
      "FTTP Express Foundation (115/20) (Included = Line Rental, Unlimited Ultrafast FTTP Broadband)",
    rrp: "£48.99",
  },
  {
    name: "FTTP Express Inclusive (115/20)",
    description:
      "FTTP Express Inclusive (115/20) (Included = Line Rental, Inclusive Calls, Unlimited Ultrafast FTTP Broadband)",
    rrp: "£54.99",
  },
  {
    name: "FTTP Ultra Foundation (160/30)",
    description:
      "FTTP Ultra Foundation (160/30) (Included = Line Rental, Unlimited Ultrafast FTTP Broadband)",
    rrp: "£50.99",
  },
  {
    name: "FTTP Ultra Inclusive (160/30)",
    description:
      "FTTP Ultra Inclusive (160/30) (Included = Line Rental, Inclusive Calls, Unlimited Ultrafast FTTP Broadband)",
    rrp: "£55.99",
  },
  {
    name: "FTTP Premium Plus (220/30)",
    description:
      "FTTP Premium Plus (220/30) (Included = Unlimited Ultrafast  FTTP Broadband)",
    rrp: "£46.99",
  },
  {
    name: "FTTP Express Plus (330/50)",
    description:
      "FTTP Express Plus (330/50) (Included = Unlimited Ultrafast  FTTP Broadband)",
    rrp: "£48.99",
  },
  {
    name: "FTTP Ultra Plus (550/75)",
    description:
      "FTTP Ultra Plus (550/75) (Included = Unlimited Ultrafast  FTTP Broadband)",
    rrp: "£50.99",
  },
  {
    name: "FTTP Ultra Premium (1000/115)",
    description:
      "FTTP Ultra Premium (1000/115) (Included = Unlimited Ultrafast  FTTP Broadband)",
    rrp: "£54.99",
  },
  {
    name: "Basic Broadband",
    description: "Line Rental, Broadband (40/10), PAYG calls",
    rrp: "£34.99",
  },
  {
    name: "Basic Connection",
    description: "Line Rental, PAYG Calls",
    rrp: "£25.99",
  },
  {
    name: "Basic Connection Fibre",
    description: "Line Rental, Fibre (40/10), PAYG Calls",
    rrp: "£43.99",
  },
  {
    name: "Basic Connection Ultra Fibre",
    description: "Line Rental, Fibre (80/20), PAYG Calls",
    rrp: "£48.99",
  },
  {
    name: "Total Broadband",
    description:
      "Line Rental, Unlimited Broadband (40/10), Inclusive UK Landline and Mobile Calls",
    rrp: "£46.99",
  },
  {
    name: "Total Connection",
    description: "Line Rental, Unlimited UK Landline and Mobile Calls",
    rrp: "£31.99",
  },
  {
    name: "Total Connection Fibre",
    description:
      "Line Rental, Unlimited Fibre (40/10), Inclusive UK Landline and Mobile Calls",
    rrp: "£47.99",
  },
  {
    name: "Total Connection Ultra Fibre",
    description:
      "Line Rental, Unlimited Fibre (80/20), Inclusive UK Landline and Mobile Calls",
    rrp: "£52.99",
  },
  { name: "RCF Rental", description: "Remote Call Forwarding", rrp: "£32.00" },
];

const additionalServices = [
  { serviceName: "Call Diversion/Forward*", nonVoIP: "£3.99", voIP: "Free" },
  { serviceName: "Wholesale 1571", nonVoIP: "£3.99", voIP: "Free" },
  { serviceName: "Call Minder Custom", nonVoIP: "£5.5", voIP: "Free" },
  { serviceName: "Call Waiting", nonVoIP: "£3.99", voIP: "Free" },
  { serviceName: "Care Level 4", nonVoIP: "£9.00", voIP: "£8.00" },
  { serviceName: "Anonymous Call Rejection", nonVoIP: "£5.50", voIP: "N/A" },
  { serviceName: "Care Level 3", nonVoIP: "£7.00", voIP: "£5.00" },
  { serviceName: "Call Barring", nonVoIP: "£3.99", voIP: "Free" },
  { serviceName: "Ring Back", nonVoIP: "£3.99", voIP: "N/A" },
  { serviceName: "Raw Call Data", nonVoIP: "£2.99", voIP: "N/A" },
  { serviceName: "Smart Divert", nonVoIP: "£4.50", voIP: "N/A" },
  { serviceName: "Static IP", nonVoIP: "£2.99", voIP: "£2.99" },
  { serviceName: "Choose to Refuse", nonVoIP: "£4.65", voIP: "N/A" },
  { serviceName: "Call Minder", nonVoIP: "£5.50", voIP: "Free" },
  { serviceName: "DDI Bundle Charges", nonVoIP: "£4.00", voIP: "N/A" },
  { serviceName: "DDI Charges", nonVoIP: "£1.00", voIP: "N/A" },
  { serviceName: "Withheld Number", nonVoIP: "£2.99", voIP: "Free" },
  { serviceName: "Call Recording Storage", nonVoIP: "N/A", voIP: "£3.00" },
  {
    serviceName: "Call Recording File Transfer",
    nonVoIP: "N/A",
    voIP: "£3.00",
  },
  { serviceName: "Call Queue", nonVoIP: "N/A", voIP: "£5.50" },
  { serviceName: "IVR Menu", nonVoIP: "N/A", voIP: "£5.50" },
  { serviceName: "Microsoft Teams Connector", nonVoIP: "N/A", voIP: "£3.50" },
  { serviceName: "Free Phone Number (0800)", nonVoIP: "N/A", voIP: "£4.50" },
  {
    serviceName: "Business Assurance and Care level 02",
    nonVoIP: "£5.00",
    voIP: "£5.00",
  },
  { serviceName: "App feature", nonVoIP: "N/A", voIP: "£5.00" },
];

const additionalCharges = [
  { chargeName: "Payment Processing Fee", amount: "£7" },
  { chargeName: "Paper Billing Charges", amount: "£5" },
  { chargeName: "Broadband Non-NGN Surcharge", amount: "£4" },
  { chargeName: "Business Assurance", amount: "£4" },
  { chargeName: "Broadband Router Configuration and Delivery", amount: "£30" },
  { chargeName: "Handset Device Configuration and Delivery", amount: "£30" },
];

const InternationalCallCharges = () => {
  return (
    <NavigationDrawer>
      <Container
        sx={{
          maxWidth: "1400px !important",
          marginTop: "80px",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Raleway",
            fontSize: { xs: "20px", sm: "35px", md: "42px" },
            color: allColors.jetBlack,
            fontWeight: "400",
            marginBottom: "30px",
            textAlign: "center",
          }}
        >
          Tariffs
        </Typography>

        <table className="simple-table" style={{ marginBottom: "30px" }}>
          <thead>
            <tr>
              <th>Package/Tariff Name</th>
              <th>Package Description</th>
              <th>RRP</th>
            </tr>
          </thead>
          <tbody>
            {tariffs.map((item) => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>{item.description}</td>
                <td>{item.rrp}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <Typography
          sx={{
            fontFamily: "Raleway",
            fontSize: { xs: "20px", sm: "35px", md: "42px" },
            color: allColors.jetBlack,
            fontWeight: "400",
            marginBottom: "30px",
            textAlign: "center",
          }}
        >
          Call Charges
        </Typography>

        <table className="simple-table" style={{ marginBottom: "30px" }}>
          <thead>
            <tr>
              <th>Call Charges – Pay as you go only</th>
              <th>Per minute</th>
            </tr>
          </thead>
          <tbody>
            {callChargesData.map((item) => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>{item.value}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <Typography
          sx={{
            fontFamily: "Raleway",
            fontSize: { xs: "20px", sm: "35px", md: "42px" },
            color: allColors.jetBlack,
            fontWeight: "400",
            marginBottom: "30px",
            textAlign: "center",
          }}
        >
          International Call Rates
        </Typography>

        <table className="simple-table" style={{ marginBottom: "30px" }}>
          <thead>
            <tr>
              <th>Call Charges – Pay as you go only</th>
              <th>Per minute</th>
              <th>Call Set Up Charge</th>
            </tr>
          </thead>
          <tbody>
            {internationalCallChargesData.map((item) => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>{item.value}</td>
                <td>{item.value2}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <Typography
          sx={{
            fontFamily: "Raleway",
            fontSize: { xs: "20px", sm: "35px", md: "42px" },
            color: allColors.jetBlack,
            fontWeight: "400",
            marginBottom: "30px",
            textAlign: "center",
          }}
        >
          Call Features & Charges
        </Typography>

        <table className="simple-table" style={{ marginBottom: "30px" }}>
          <thead>
            <tr>
              <th>Additional Services</th>
              <th>Non-VoIP</th>
              <th>VoIP</th>
            </tr>
          </thead>
          <tbody>
            {additionalServices.map((item) => (
              <tr key={item.id}>
                <td>{item.serviceName}</td>
                <td>{item.nonVoIP}</td>
                <td>{item.voIP}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <Typography
          sx={{
            fontFamily: "Raleway",
            fontSize: { xs: "20px", sm: "35px", md: "42px" },
            color: allColors.jetBlack,
            fontWeight: "400",
            marginBottom: "30px",
            textAlign: "center",
          }}
        >
          All Other Charges
        </Typography>

        <table className="simple-table" style={{ marginBottom: "30px" }}>
          <thead>
            <tr>
              <th>Ad hoc Services/Charges</th>
              <th>RRP</th>
            </tr>
          </thead>
          <tbody>
            {additionalCharges.map((item) => (
              <tr key={item.id}>
                <td>{item.chargeName}</td>
                <td>{item.amount}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <Typography
          sx={{
            fontFamily: "Raleway",
            fontSize: { xs: "14px" },
            color: allColors.jetBlack,
            fontWeight: "400",
            marginBottom: "30px",
          }}
        >
          All prices above exclude VAT.
        </Typography>
      </Container>
    </NavigationDrawer>
  );
};

export default InternationalCallCharges;
